export const searchOutput = [
  { title: "Men Shirts", link: "/product/MensData" },
  { title: "Men Jackets", link: "/product/MensData" },
  { title: "Men Jeans", link: "/product/MensData" },
  { title: "Men Shorts", link: "/product/MensData" },
  { title: "Men Sweaters", link: "/product/MensData" },
  { title: "Men Clothing set", link: "/product/MensData" },
  { title: "Clothes for Men", link: "/product/MensData" },
  { title: "Men Casual", link: "/product/MensData" },
  { title: "Mens Causal Shirts", link: "/product/MensData" },
  { title: "shirts Men formal", link: "/product/MensData" },
  { title: "shirts Men Casual", link: "/product/MensData" },
  { title: "shirts Cotton", link: "/product/MensData" },
  { title: "Women Kurtas", link: "/product/WomensData" },
  { title: "Women tops", link: "/product/WomensData" },
  { title: "Women Jeans", link: "/product/WomensData" },
  { title: "Women Dresses", link: "/product/WomensData" },
  { title: "Women Casual", link: "/product/WomensData" },
  { title: "Kids Clothes", link: "/product/ChildrensData" },
  { title: "Kids Dresses", link: "/product/ChildrensData" },
  { title: "Kids girls", link: "/product/ChildrensData" },
  { title: "Kids boys", link: "/product/ChildrensData" },
];
